import isBrowser from './isBrowser'

const noop = () => {}

// very small wrapper around segment analytics to make sure that if segment is not available (e.g. if the user has an adblocker) we don't get errors
const analytics = {
  identify:
    isBrowser() && window?.analytics?.identify
      ? // straight up returning identify doesn't work for some reason
        (...args) => window.analytics.identify(...args)
      : noop,
  trackPageView:
    isBrowser() && window?.analytics?.page
      ? (path) => {
          const url = new URL(path)
          window.analytics.page({ path: url.pathname, search: url.search })
        }
      : noop,
  fireEvent:
    isBrowser() && window?.analytics?.track
      ? (event, properties) => {
          window.analytics.track(event, properties)
        }
      : noop,
}

export default analytics
